const s = "svg_cQxH3", t = {
  svg: s
};
export {
  t as default,
  s as svg
};
//# sourceMappingURL=barcode.module.scss.js.map
